import { useEffect, useState } from "react";
import api from "../api/axiosInstance";

const toOptions = (skills) =>
  (skills || []).map((s) => ({
    value: s.value || s.name,
    label: s.name,
  }));

export const useSkills = (category) => {
  const [skills, setSkills] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        setLoading(true);
        setError(null);
        const url = category ? `/skills?category=${encodeURIComponent(category)}` : "/skills";
        const { data } = await api.get(url);
        setSkills(data || []);
        setOptions(toOptions(data || []));
      } catch (err) {
        setError(err.response?.data?.message || err.message || "Failed to fetch skills");
        setSkills([]);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSkills();
  }, [category]);

  return { skills, options, loading, error };
};

/** Returns tech skills (excluding soft) for Projects/AdminSearch dropdowns */
export const useTechSkills = () => {
  const { skills, loading, error } = useSkills();
  const techOptions = (skills || []).filter((s) => s.category !== "soft").map((s) => ({
    value: s.value || s.name,
    label: s.name,
  }));

  return { skills: techOptions, options: techOptions, loading, error };
};
